<template>
    <div>
        <viewer v-if="isKonfirmasi" :isKonfirmasi="isKonfirmasi" :value="form" @koreksi="isKonfirmasi = false" @saved="save"></viewer>
        <b-card v-show="!isKonfirmasi" class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 class="modal-title">{{ isEdit ? 'Edit Tebasan' : 'Tebasan' }}</h5>
            </b-card-header>
            <b-card-body>
                <div class="form-group">
                    <label class="form-control-label">Supplier</label>
                    <div class="input-group mb-0 d-flex">
                        <multiselect class="w-auto flex-grow-1" v-validate="'required'" name="supplier" v-model="form.supplier" :options="supplierOptions" :placeholder="'Pilih supplier'" :searchable="true"
                            label="name" track-by="id" :show-labels="false"></multiselect>
                        <div class="input-group-append">
                            <button class="btn btn-primary" type="button" @click="selectSupplier = true"><i class="fas fa-search"></i> Pilih Supplier</button>
                        </div>
                    </div>
                    <span class="text-danger">{{ errors.first('supplier') }}</span>
                </div>

                <div class="form-group">
                    <label>Jumlah</label>
                    <div class="input-group mb-0 d-flex">
                        <input v-validate="'required|min_value:0'" min="0" v-model="form.jumlah" type="number" name="jumlah" class="form-control">
                        <div class="input-group-append">
                            <span class="input-group-text" id="basic-addon2">tanaman</span>
                        </div>
                    </div>
                    <span class="text-danger">{{ errors.first('jumlah') }}</span>
                </div>

                <div class="form-group">
                    <label>Harga</label>
                    <input v-validate="'required|min_value:0'" min="0" v-model="form.harga" type="number" name="harga" class="form-control">
                    <span class="text-danger">{{ errors.first('harga') }}</span>
                </div>

                <div class="form-group">
                    <label>DP</label>
                    <input v-validate="'required|min_value:0'" min="0" v-model="form.dp" type="number" name="dp" class="form-control">
                    <span class="text-danger">{{ errors.first('dp') }}</span>
                </div>

                <div class="form-group">
                    <label class="form-control-label">Metode</label>
                    <multiselect v-validate="'required'" class="w-auto flex-grow-1" name="metode" v-model="form.metode_pembayaran" :options="metodeOptions"
                        label="value" track-by="name" :allowEmpty="false" placeholder="" :show-labels="false"></multiselect>
                    <span class="text-danger">{{ errors.first('metode') }}</span>
                </div>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <button :disabled="isLoading" v-if="!isKonfirmasi" @click="$emit('cancel')" type="button" class="btn btn-secondary" data-dismiss="modal">{{ viewMode ? 'OK' : 'Batal' }}</button>
                <button :disabled="isLoading" v-if="!isEdit && !isKonfirmasi && !viewMode" @click="konfirmasi" type="button" class="btn btn-primary mr-2">Simpan</button>
                <button :disabled="isLoading" v-if="isEdit" @click="save(false)" type="button" class="btn btn-primary mr-2">Simpan</button>
                <button :disabled="isLoading" v-if="isKonfirmasi" @click="koreksi" type="button" class="btn btn-secondary">Koreksi</button>
                <button :disabled="isLoading" v-if="isKonfirmasi" @click="save(true)" type="button" class="btn btn-primary mr-2">Cetak</button>
            </b-card-footer>
        </b-card>

        <b-modal v-model="selectSupplier" size="lg" :hide-header="true" :hide-footer="true">
            <supplier-selector :gudang-id="form.gudang ? form.gudang.id : null" :selected="supplierOptions" @selected="supplierSelected" @cancel="selectSupplier = false"></supplier-selector>
        </b-modal>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import SupplierSelector from '../suppliers/Selector';
import Viewer from './Viewer';

export default {
    name: "tebasan-form",

    props: {
        isEdit: {
            type: Boolean,
            default: () => {},
        },

        value: {
            type: Object,
            default: null,
        }
    },

    components: {
        Multiselect,
        SupplierSelector,
        Viewer,
    },

    data() {
        return {
            form: null,
            selectSupplier: false,
            supplierOptions: [],
            isKonfirmasi: false,
            metodeOptions: [
                {
                    name: 'tunai',
                    value: 'Tunai',
                },
                {
                    name: 'transfer',
                    value: 'Transfer',
                },
            ],
        }
    },

    created() {
        this.resetForm();
    },

    mounted() {
        if (this.value) {
            this.initForm();
        }
    },

    computed: {
    },

    watch: {
        value() {
            this.initForm();
        }
    },

    methods: {
        initForm() {
            let self = this;
            self.form = Object.assign({}, self.value);
            if (self.form.supplier) {
                self.supplierOptions.push(Object.assign({}, self.form.supplier));
            }
            let metodeIndex = self.metodeOptions.findIndex(option => option.name == self.form.metode_pembayaran);
            self.form.metode_pembayaran = Object.assign({}, self.metodeOptions[metodeIndex]);
        },
        resetForm() {
            this.form = Object.assign({}, {
                form: {
                    id: '',
                    supplier: null,
                    jumlah: '',
                    harga: '',
                    dp: '',
                    metode_pembayaran: null,
                }
            });
        },

        konfirmasi() {
            let self = this;

            self.$validator.validateAll().then(result => {
                if (result) {
                    self.isKonfirmasi = true;
                }
            });
        },

        save() {
            let self = this;

            self.isLoading = true;
            let data = {
                supplier_id: self.form.supplier.id,
                jumlah: self.form.jumlah,
                harga: self.form.harga,
                dp: self.form.dp,
                metode_pembayaran: self.form.metode_pembayaran ? self.form.metode_pembayaran.name : null,
            }

            self.$Progress.start();
            axios({
                method: self.isEdit ? 'put' : 'post',
                url: self.isEdit ? '/api/tebasans/'+self.form.id : '/api/tebasans',
                data: data
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                self.isLoading = false;
                self.$Progress.finish();
                self.$emit('saved');
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },

        supplierSelected(supplier) {
            let self = this;

            if (!self.form.gudang) {
                self.gudangOptions = [];
            }
            self.supplierOptions = [];
            self.supplierOptions.push(supplier);
            self.form.supplier = Object.assign({}, supplier);
            self.selectSupplier = false;
        },

        print(data) {
            let self = this;

            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            newIframe.src = '/tebasans/print/'+data.id;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
                self.$emit('saved', data);
            }
        },

        koreksi() {
            this.isKonfirmasi = false;
        },
    },
}
</script>
<style>
.multiselect__placeholder {
    margin-bottom: 0;
}

th, td {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
}
</style>
